import { useSetAtom } from "jotai";
import { useCallback, useEffect } from "react";

import { bookmarkAtom } from "./atoms";

export const useBookmarkRippleEffectSetup = () => {
  const setBookmark = useSetAtom(bookmarkAtom);

  const toggleBookmarkRippleEffect = useCallback(
    (smallRipple?: boolean) => {
      setBookmark(previousState => ({
        ...previousState,
        showRippleEffect: true,
        showSmallRipple: smallRipple ?? false,
      }));
      setTimeout(() => {
        setBookmark(previousState => ({
          ...previousState,
          showRippleEffect: false,
        }));
      }, 600);
    },
    [setBookmark],
  );

  const toggleShowNewBookmarkAnimation = useCallback(
    (state: boolean) =>
      setBookmark(previousState => ({ ...previousState, showNewBookmarkAnimation: state })),
    [setBookmark],
  );

  useEffect(() => {
    setBookmark(previousState => ({
      ...previousState,
      toggleBookmarkRippleEffect,
      toggleShowNewBookmarkAnimation,
    }));
  }, [setBookmark, toggleBookmarkRippleEffect, toggleShowNewBookmarkAnimation]);
};
